import React from 'react';
import { useAppDispatch } from '../../store/store';
import { removeRange, editRange } from '../pdf-slice';
import { Range } from '../../store/app-state';

require('./pdf-range-input.scss');

export interface RangeInputProps {
  range: Range;
  i: number;
}

export const RangeInput: React.FC<RangeInputProps> = ({ range, i }) => {
  const dispatch = useAppDispatch();

  return (
    <div className="pdf-range-input__container">
      <div className="pdf-range-input__title">{`Range ${i + 1}`}</div>
      <div className="pdf-range-input__row">
        <div className="pdf-range-input__text">from page</div>
        <input
          type="number"
          className="pdf-range-input__input"
          defaultValue={range.fromPage}
          placeholder="1"
          min={1}
          onChange={(e) =>
            dispatch(
              editRange({
                index: i,
                fromPage: e.target.value,
                toPage: range.toPage,
                name: range.name,
              }),
            )
          }
          onBlur={(e) => {
            const tp = parseInt(e.target.value);
            if (tp && range.toPage && tp > range.toPage) {
              e.target.value = range.toPage.toString();
              dispatch(
                editRange({
                  index: i,
                  toPage: range.toPage,
                  fromPage: range.toPage,
                  name: range.name,
                }),
              );
            }
          }}
        />
        <p className="pdf-range-input__input-text">to</p>
        <input
          type="number"
          className="pdf-range-input__input"
          defaultValue={range.toPage}
          placeholder="1"
          min={1}
          onChange={(e) =>
            dispatch(
              editRange({
                index: i,
                toPage: e.target.value,
                fromPage: range.fromPage,
                name: range.name,
              }),
            )
          }
          onBlur={(e) => {
            const tp = parseInt(e.target.value);
            if (tp && range.fromPage && tp < range.fromPage) {
              e.target.value = range.fromPage.toString();
              dispatch(
                editRange({
                  index: i,
                  toPage: range.fromPage,
                  fromPage: range.fromPage,
                  name: range.name,
                }),
              );
            }
          }}
        />
        <div
          className="pdf-range-input__button"
          onClick={() => dispatch(removeRange(i))}
        ></div>
      </div>
    </div>
  );
};
